import AppearOnScroll from "./AppearOnScroll"

function Island(props) {

    return (
      <div className="flex w-full py-12 px-8 bg-lightgrey shadow-md items-start rounded-image">
        <div className="flex flex-col gap-4">
          <AppearOnScroll>
          <h3 className="font-display font-medium text-dark-900 text-2xl xl:text-2xl text-left">Reflection</h3>
          </AppearOnScroll>
          <AppearOnScroll delay={0.3}>
          <p className="md:w-80 text-left leading-relaxed text-dark-900 font-body font-normal text-lg xl:text-xl">{props.children}</p>  
          </AppearOnScroll>
        </div>
      </div>
      
    )
  }
  
  export default Island